import React from 'react'
import PropTypes from 'prop-types';

import Label from '../label';
import Icon from '../icon/icons/icon';
import * as models from '../icon/icons';

import './button.styl'
class Button extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        disabled: PropTypes.bool,
        icon: PropTypes.string,
        onClick: PropTypes.func.isRequired
    }

    handleChange(event){
        event.preventDefault();
        if(this.props.disabled) return

        this.props.onClick(event)
    }

    render() {
        let { icon=false, label=false, className=false, disabled=false, children=false } = this.props;

        icon && models[icon] && models[icon].length && (icon = models[icon]);

        className = 'button' + (className ? ' ' + className : '')
        disabled && (className = className + ' disabled')

        return <div className={className} onClick={this.handleChange.bind(this)} >
            {icon && <Icon svg={icon} />}
            {label && <Label>{label}</Label> }
            {children ? children : ''}
        </div>;
    }
}

export default Button
